import { Answer, Question, QuestionnaireService, ThemeSelection } from "@/types/questionnaire";
import BaseCard from "./BaseCard";

interface Properties {
    questionnaire: Question,
    redoQuestionnaire: () => void,
    completedThemes: {[key: number]: Answer}
}

function Summary(properties: Properties): JSX.Element {
    const selectedAnswers: ThemeSelection[] = QuestionnaireService.getCheckedAnswersByTheme(properties.questionnaire, properties.completedThemes);

    const onClickRedoQuestionnaire = function() {
        properties.redoQuestionnaire();
    }

    return (
    <>
        <div className="relative flex flex-col w-full gap-5 h-full">
            <BaseCard hideOverflow={false}>
                <div className="flex mb-2">
                    <h3 className="flex-1">Even een check</h3>
                </div>
                <p>Als we het goed begrijpen dan kan jij hulp gebruiken bij:</p>
                <div className="mt-2">
                { selectedAnswers.map((themeSelection: ThemeSelection, index: number) => {
                    return <div key={themeSelection.theme.id}>
                        <h5>{ themeSelection.theme.title ?? "Onbekend Thema" }</h5>
                        <ul style={{ listStyle: "disc", paddingInlineStart: "1em"}}>
                        { themeSelection.selected.map((selectedAnswer: Answer, answerIndex: number) => {
                            return <li key={selectedAnswer.id}>{selectedAnswer.result ?? "Onbekend antwoord"}</li>
                        })}
                        </ul>
                    </div>
                })}
                </div>
                
                <div className="flex mt-4">
                    <h4 className="flex-1">Nog een onderdeel toevoegen?</h4>
                </div>
                <p>Je kan nu nog een onderwerp toevoegen zodat het onderdeel uitmaakt van je advies.</p>
                <button
                    className="btn btn-primary-outline flex-1 font-bold mt-2 p-1"
                    style={{ "padding": "6px 16px"}}
                    onClick={ onClickRedoQuestionnaire }
                >
                    <i className="fas fa-plus text-xl"></i>
                    Nog een onderwerp toevoegen
                </button>
            </BaseCard>
        </div>
    </>
    )
}

export default Summary;